import React, { Component } from 'react'
import styled from 'styled-components'
import LazyLoad from 'react-lazy-load'
import { Image } from 'cloudinary-react'

import Clip from './Clip'

const Container = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  max-width: 900px;
  margin: 0 auto;
  padding: 100px 15px 50px 15px;
  overflow-x: hidden;
`
const Avatar = styled.img`
  border-radius: 50%;
  width: 250px;
  height: 250px;
  @media (min-width: 650px) {
    flex: 1 auto;
    height: auto;
  }
`
const Bio = styled.div`
  @media (min-width: 650px) {
    flex: 11;
    padding-left: 50px;
  }
`
const Name = styled.p`
  font-size: 80px;
  padding-bottom: 5px;
  margin-left: -5px;
`
const Title = styled.p`
  font-size: 40px;
  padding-bottom: 10px;
`
const Copy = styled.p`
  line-height: 1.5;
`
const Headline = styled.h1`
  font-size: 60px;
  margin-bottom: 50px;
`
const ImgLeft = styled.div`
  margin-bottom: 35px;
  @media (min-width: 500px) {
    transform: translate(-5%);
    margin-bottom: 75px;
  }
`
const ImgRight = styled.div`
  margin-bottom: 35px;
  @media (min-width: 500px) {
    transform: translate(5%);
    margin-bottom: 75px;
  }
`

class Work extends Component {
  render() {
    return (
      <Container>
        <Headline>Work</Headline>
        <ImgLeft>
          <LazyLoad>
            <Image
              cloudName="mattcdowning"
              publicId="press-success_sjje7z.png"
              fetchFormat="auto"
              alt="press success"
              secure
            />
          </LazyLoad>
        </ImgLeft>
        <ImgRight>
          <LazyLoad>
            <Image
              cloudName="mattcdowning"
              publicId="mux_ifybey.png"
              fetchFormat="auto"
              alt="mux"
              secure
            />
          </LazyLoad>
        </ImgRight>
        <ImgLeft>
          <LazyLoad>
            <Image
              cloudName="mattcdowning"
              publicId="sda_qfizag.png"
              fetchFormat="auto"
              alt="sDA cPA"
              secure
            />
          </LazyLoad>
        </ImgLeft>
        <ImgRight>
          <LazyLoad>
            <Image
              cloudName="mattcdowning"
              publicId="succentrix_mpvsc4.png"
              fetchFormat="auto"
              alt="succentrix"
              secure
            />
          </LazyLoad>
        </ImgRight>
        <ImgLeft>
          <LazyLoad>
            <Image
              cloudName="mattcdowning"
              publicId="walkga_kymng7.png"
              fetchFormat="auto"
              alt="walk georgia"
              secure
            />
          </LazyLoad>
        </ImgLeft>
        <ImgRight>
          <LazyLoad>
            <Image
              cloudName="mattcdowning"
              publicId="ben-hardy_xr22qs.png"
              fetchFormat="auto"
              alt="benjamin hardy"
              secure
            />
          </LazyLoad>
        </ImgRight>
        <ImgLeft>
          <LazyLoad>
            <Image
              cloudName="mattcdowning"
              publicId="margot_brbkie.png"
              fetchFormat="auto"
              alt="margot and caleb wedding"
              secure
            />
          </LazyLoad>
        </ImgLeft>
        <ImgRight>
          <LazyLoad>
            <Image
              cloudName="mattcdowning"
              publicId="nlu_niffml.png"
              fetchFormat="auto"
              alt="no laying up"
              secure
            />
          </LazyLoad>
        </ImgRight>
        <Clip />
      </Container>
    )
  }
}
export default Work



// WEBPACK FOOTER //
// /opt/build/repo/src/containers/Work.js